/** Shared UTC calendar date prevents SSR/browser timezone hydration differences. */
export function communityDate(createdAt:string,locale:string) {
 return new Date(createdAt.replace(' ','T')+'Z').toLocaleDateString(locale,{timeZone:'UTC'})
}
